export const sortByCreatedAt = <
  T extends { attributes: { created_at?: string } }
>(
  list: Array<T>
): Array<T> => {
  return list.sort((a, b) => {
    return Number(a.attributes.created_at)! - Number(b.attributes.created_at)!;
  });
};
